<ul>
  @for (item of items; track $index) {
  <li>
    @if((item.children?.length??0) > 0) {
    <button role="menuitem"
            type="button"
            [attr.data-id]="item.id"
            popovertarget="headerMenu"
            popovertargetaction="show"
            onclick="if(globalThis.innerWidth <= 1024){headerMenu.showModal()} else {headerMenu.togglePopover()}; headerMenu.querySelector('[open]')?.removeAttribute('open'); document.getElementById(this.dataset.id).setAttribute('open','');">{{ item.title }}</button>
    } @else {
    <a role="menuitem"
       [href]="item.link"
       [attr.target]="item.target != null ? item.target : null">{{ item.title }}</a>
    }
  </li>
  }
</ul>
